import { MarketCardListSkeleton } from './market-card-skeleton';
import { Skeleton } from '@/client/components/ui/skeleton';

/**
 * Route-transition fallback for the home page. Mirrors the real page's
 * wrapper and card-grid classes (pages/home + market-list/card-list.tsx) so
 * the swap-in doesn't shift layout.
 */
export const HomePageSkeleton = () => (
  <section className="w-full pb-18 md:pb-14 min-h-full">
    <div className="max-w-[1400px] mx-auto">
      {/* Hero placeholder */}
      <div className="px-4 md:px-6 pt-6 space-y-3">
        <Skeleton className="h-8 w-2/3 md:w-1/3" />
        <Skeleton className="h-4 w-1/2 md:w-1/4" />
        <div className="flex gap-2 pt-2">
          <Skeleton className="h-9 w-24 rounded-full" />
          <Skeleton className="h-9 w-24 rounded-full" />
        </div>
      </div>
      {/* Card grid placeholder -- same classes as TheMarketCardList */}
      <div className="px-4 md:px-6 py-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
          <MarketCardListSkeleton len={8} />
        </div>
      </div>
    </div>
  </section>
);
